module.exports = __webpack_public_path__ + "img/pro_one.90bf9889.jpg";